module.exports = __webpack_public_path__ + "img/6.81525e68.jpg";